export const peHEURL = "http://n.game-vp.com/tallyman/v1/?action=validate-access&country=pe&domain=pe.game-lords.com&platform=mcb&product_page=https://loginprime.com/GOaAZO"


// WEBPACK FOOTER //
// ./src/constants/heURL.js